import { render, staticRenderFns } from "./RestoreList.vue?vue&type=template&id=423e7fea"
import script from "./RestoreList.vue?vue&type=script&lang=js"
export * from "./RestoreList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports